'use client';

import { createContext, useContext, ReactNode } from 'react';
import type { FeatureFlags } from '@src/flags';
const FeatureFlagsContext = createContext<FeatureFlags | null>(null);
export function FeatureFlagsProvider({
  flags,
  children
}: {
  flags: FeatureFlags;
  children: ReactNode;
}) {
  return <FeatureFlagsContext.Provider value={flags} data-sentry-element="FeatureFlagsContext.Provider" data-sentry-component="FeatureFlagsProvider" data-sentry-source-file="FeatureFlagsProvider.tsx">
      {children}
    </FeatureFlagsContext.Provider>;
}
export function useFeatureFlags(): FeatureFlags {
  const flags = useContext(FeatureFlagsContext);
  if (!flags) {
    throw new Error('useFeatureFlags must be used within FeatureFlagsProvider');
  }
  return flags;
}